import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from './View/Home';
import Login from "./View/Login";
import Dashboard from "./View/Dashboard";
import { useSelector } from "react-redux"


function App(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.isLoggedIn);
  const { auth } = useSelector((state) => state)

  useEffect(() => {
    setIsLoggedIn(localStorage.isLoggedIn)
  }, [localStorage, auth.isAuthenticated])


  return (
    <>
      {
        isLoggedIn ?
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
          :
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
      }
    </>
  );
}

export default App;